import L from "leaflet";

export class Icon {

    private _path: string;
    private _icon: L.Icon;

    constructor(path: string, icon: L.Icon) {
        this._path = path;
        this._icon = icon;
    }

    get path(): string {
        return this._path;
    }

    set path(value: string) {
        this._path = value;
    }

    get icon(): L.Icon {
        return this._icon;
    }

    set icon(value: L.Icon) {
        this._icon = value;
    }

    public static remapObjectToIcon(object: any): Icon | null {
        let icon: Icon | null = null;
        if(object._path && object._icon) {
            icon = new Icon(
                object._path,
                object._icon
            );
        }
        return icon;
    }
}
